// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ycfk","name":"Header_name__1RA2P","birthday":"Header_birthday__2pReQ","skeleton":"Header_skeleton__1dk4s"};